var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8334C12.3012 10.8334 14.1667 8.96789 14.1667 6.66669C14.1667 4.36549 12.3012 2.5 10 2.5C7.69883 2.5 5.83334 4.36549 5.83334 6.66669C5.83334 8.96789 7.69883 10.8334 10 10.8334Z",
    fill: "#858C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99362 15.8766C2.99815 13.4449 6.20244 11.6667 10 11.6667C13.7976 11.6667 17.0019 13.4449 18.0064 15.8766C18.3579 16.7274 17.5872 17.5001 16.6667 17.5001H3.33332C2.41284 17.5001 1.64219 16.7274 1.99362 15.8766Z",
    fill: "#858C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.98e88d991f66a3417d9c4034797d2ee2.svg";
export { ForwardRef as ReactComponent };